var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('project-info-panel',{attrs:{"workflow-apply-record-id":_vm.id}}),_c('fixed-deposit-panel',{attrs:{"workflow-apply-record-id":_vm.id}}),_c('status-info-panel',{attrs:{"workflow-apply-record-id":_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }